module.exports = __webpack_public_path__ + "assets/pdf/E05-cn-satellite-instrument.0b3ee5b7.pdf";